import dayjs from "dayjs"
import { CUSTOM_TIME_FORMAT } from "constants"

export const clientInsightsTransformer = response => {
  const data = response?.data ?? {}

  const resolveBestMessagingWindow = () => {
    const hours = data?.bestTimeToMessage ?? []
    if (!hours.length) {
      return { timeRange: null, isCurrentHourBest: false, bestHour: null }
    }

    const top = hours.reduce((max, item) => (item?.score > max?.score ? item : max), { hour: 0, score: 0 })

    if (top?.score === 0) {
      return { timeRange: null, isCurrentHourBest: false, bestHour: null }
    }

    const start = dayjs().hour(top?.hour).minute(0).second(0)
    const end = start.add(1, "hour")

    return {
      timeRange: `${start.format(CUSTOM_TIME_FORMAT)} - ${end.format(CUSTOM_TIME_FORMAT)}`,
      isCurrentHourBest: dayjs().isAfter(start) && dayjs().isBefore(end),
      bestHour: top?.hour,
    }
  }

  const transformThemes = themes => {
    const total = Object.values(themes ?? {}).reduce((sum, count) => sum + count, 0)
    return Object.entries(themes ?? {})
      .map(([label, count]) => ({
        label,
        count,
        percent: total ? Math.round((count / total) * 100) : 0,
      }))
      .sort((a, b) => b.percent - a.percent)
  }

  const transformProjects = projects =>
    projects?.map(({ projectName, count }) => ({ name: projectName, count })).sort((a, b) => b?.count - a?.count)

  const transformScoresBreakdown = scores => {
    const breakdown = {}
    scores.forEach(item => {
      breakdown[item?.theme] = {
        totalScore: item?.totalScore,
        scores: Object.entries(item?.meanScores ?? {}).map(([label, scoreData]) => ({
          label: label.replace(/([A-Z])/g, " $1").trim(),
          score: scoreData?.value,
          total: scoreData?.total,
          percent: scoreData?.total ? Math.round((scoreData?.value / scoreData.total) * 100) : 0,
        })),
      }
    })
    return breakdown
  }

  const overall = data.overallAnalysis ?? {}
  const scores = overall.overallScores ?? []
  const messaging = resolveBestMessagingWindow()

  return {
    totalConversations: data?.totalConversations ?? 0,
    overallEngagementScore: data?.overallEngagementScore ?? "",
    qualifiedConversations: data?.qualifiedConversations ?? 0,
    relevantConversations: data?.relevantConversations ?? 0,
    highEngagementConversations: data?.highEngagementConversations ?? 0,

    bestMessageHour: messaging?.timeRange,
    bestTimeToMessage: messaging?.timeRange,
    isCurrentHourBest: messaging?.isCurrentHourBest,
    bestHour: messaging?.bestHour,

    overallSummary: overall?.overallSummary ?? "",
    overallThemes: transformThemes(overall?.overallThemes),
    overallProjects: transformProjects(overall?.overallProjectsDiscussed ?? []),
    topThreeProjects: overall?.topThreeProjects ?? {},
    nextSteps: overall?.nextSteps ?? [],

    scoresBreakdown: transformScoresBreakdown(scores),
    overallThemeTotals: scores.map(item => ({
      label: item?.theme,
      score: item?.totalScore?.value,
      total: item?.totalScore?.total,
    })),
    overallScore: scores.length
      ? Math.round(scores.reduce((sum, s) => sum + (s?.totalScore?.value ?? 0), 0) / scores.length)
      : 0,
  }
}
